export const IosModalClosedKey = 'ios-modal-closed';
